// CONTRACT VARIABLES
const variables = [
  {
    text: "&Loppu",
    value: "/if",
    type: "function",
    show: [1, 2],
  },
  {
    text: "#Loppu",
    value: "/ifCond",
    type: "function",
    show: [1, 3],
  },
  {
    text: "Muuten",
    value: "else",
    type: "function",
    show: [1, 2],
  },
  {
    text: "#Kaksi vierekkäin alkaa",
    value: "twoSideBySide",
    type: "function",
    show: [1, 2, 3],
  },
  {
    text: "#Vierekkäin lohko",
    value: "sideBySideItem",
    type: "function",
    show: [1, 2, 3],
  },
  {
    text: "#Vierekkäin loppuu",
    value: "endDiv",
    type: "function",
    show: [1, 2, 3],
  },
  {
    text: "#Useat loppuu",
    value: "/each",
    type: "function",
    show: [1, 2, 3],
  },

  // LANDLORDS
  {
    text: "#Useat vuokranantajat alkaa",
    value: "#each landlords as |landlord index|",
    type: "function",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan nimi",
    value: "landlord.name",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan henkilötunnus tai y-tunnus",
    value: "socialOrBusinessId landlord",
    type: "function",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan osoite",
    value: "landlord.address",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan postinumero",
    value: "landlord.zipCode",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan kaupunki",
    value: "landlord.city",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan puhelin",
    value: "landlord.phone",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan email",
    value: "landlord.email",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokranantajan pankki",
    value: "landlord.bank",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokranantajan tilinumero",
    value: "landlord.iban",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "&Jos Vuokranantajan tilitiedot",
    value: "#if landlord.iban",
    type: "function",
    show: [1, 2],
  },

  // TENANT
  {
    text: "Vuokralaisen nimi",
    value: "tenant.name",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokralaisen henkilötunnus tai y-tunnus",
    value: "socialOrBusinessId tenant",
    type: "function",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen osoite",
    value: "tenant.address",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen puhelin",
    value: "tenant.phone",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen email",
    value: "tenant.email",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen postinumero",
    value: "tenant.zipCode",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen kaupunki",
    value: "tenant.city",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Vuokralaisen yhteyshenkilö",
    value: "tenant.contactPersonName",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokralaisen yhteyshenkilön puh.",
    value: "tenant.contactPersonPhone",
    type: "variable",
    show: [1],
  },
  {
    text: "#Useat muut vuokralaiset alkaa",
    value: "#each otherTenants as |tenant index|",
    type: "function",
    show: [1, 2],
  },

  // APARTMENT
  {
    text: "Vuokrakohteen osoite",
    value: "apartment.address",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokrakohteen numero",
    value: "apartment.apartmentNumber",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokrakohteen postinumero",
    value: "apartment.zipCode",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Vuokrakohteen postitoimipaikka",
    value: "apartment.city",
    type: "variable",
    show: [1, 2, 3],
  },
  {
    text: "Kohteen / Huoneiston kokoonpano",
    value: "apartment.floorPlan",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Pinta-ala",
    value: "apartment.area",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Muut tilat",
    value: "apartment.otherRooms",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Taloyhtiön tulevat remontit",
    value: "apartment.repairsWaiting",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos vuokrataan nykyisessä kunnossa",
    value: "#if apartment.condition",
    type: "function",
    show: [1],
  },
  {
    text: "Vuokrakohteen kunnon tarkastuspäivä",
    value: "apartmentConditionCheckDate",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos vuokrakohde valokuvataan",
    value: "#if apartment.photos",
    type: "function",
    show: [1],
  },

  // KEYS
  {
    text: "#Useat avaimet alkaa",
    value: "#each keys as |key index|",
    type: "function",
    show: [2],
  },
  {
    text: "Avaimen nimi/koodi",
    value: "key.code",
    type: "variable",
    show: [2],
  },

  // LEASE
  {
    text: "Sopimuksen tyyppi",
    value: "lease.leaseType",
    type: "variable",
    show: [1],
  },
  {
    text: "Sopimuksen alkamispäivä",
    value: "startDate",
    type: "variable",
    show: [1],
  },
  {
    text: "Sopimuksen päättymispäivä",
    value: "endDate",
    type: "variable",
    show: [1],
  },
  {
    text: "#Jos määräaikainen sopimus",
    value: "#ifCond lease.leaseType '==' 'Määräaikainen'",
    type: "function",
    show: [1],
  },
  {
    text: "Vuokranmaksun alkamispäivä",
    value: "firstRentDate",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos ensimmäinen irtisanomispäivä näytetään",
    value: "#if lease.showDismissalDate",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos poismuuttopäivä AHVL",
    value: "#ifCond lease.moveOut '==' 'AHVL'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos poismuuttopäivä LHVL",
    value: "#ifCond lease.moveOut '==' 'LHVL'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos poismuuttopäivä sopimuksen päättymispäivä",
    value: "#ifCond lease.moveOut '==' 'endDate'",
    type: "function",
    show: [1],
  },
  {
    text: "Ensimmäinen mahdollinen irtisanomispäivä",
    value: "dismissalDate",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokran määrä €",
    value: "rentAmount",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokran eräpäivä",
    value: "lease.rentDueDate",
    type: "variable",
    show: [1],
  },
  {
    text: "Sisäänmuutto / hallintaoikeus pvm.",
    value: "moveInDate",
    type: "variable",
    show: [1],
  },

  // CHARGES
  {
    text: "Vesimaksun hinta",
    value: "waterChargePerMonth",
    type: "variable",
    show: [1],
  },
  {
    text: "Vesimaksujen määrä",
    value: "lease.waterChargeCount",
    type: "variable",
    show: [1],
  },
  {
    text: "#Jos vesimaksuennakko",
    value: "#ifCond lease.waterChargeType '==' 'usage'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vesimaksun kiinteä summa",
    value: "#ifCond lease.waterChargeType '==' 'fixed'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vesimaksun sisältyy vuokraan",
    value: "#ifCond lease.waterChargeType '==' 'included'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos ei vesimaksua",
    value: "#ifCond lease.waterChargeType '==' 'noCharge'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vuokralaisen oma sähkösopimus",
    value: "#ifCond lease.electricity '==' 'own'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteä sähkömaksu",
    value: "#ifCond lease.electricity '==' 'fixed'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos sähkömaksu sisältyy vuokraan",
    value: "#ifCond lease.electricity '==' 'included'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos ei sähkömaksua",
    value: "#ifCond lease.electricity '==' 'noCharge'",
    type: "function",
    show: [1],
  },
  {
    text: "Sähkömaksu €",
    value: "electricityAmount",
    type: "variable",
    show: [1],
  },
  {
    text: "Saunamaksu €",
    value: "saunaCost",
    type: "variable",
    show: [1],
  },
  {
    text: "Pyykkitupamaksu €",
    value: "laundretteCost",
    type: "variable",
    show: [1],
  },
  {
    text: "Autopaikkamaksu €",
    value: "parkingCost",
    type: "variable",
    show: [1],
  },
  {
    text: "Muut kustannukset kuvaus",
    value: "lease.otherCostsDetails",
    type: "variable",
    show: [1],
  },
  {
    text: "Muut kustannukset hinta",
    value: "otherCosts",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos laskutus integraation kautta käytössä (#useat sisällä)",
    value: "#if ../others.eInvoice",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos laskutus integraation kautta käytössä",
    value: "#if others.eInvoice",
    type: "function",
    show: [1],
  },

  // DEPOSIT
  {
    text: "&Jos vakuutta käytetään",
    value: "#if lease.useDeposit",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vakuus laskutetaan",
    value: "#ifCond lease.depositType '==' 'invoice'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos digivakuus",
    value: "#ifCond lease.depositType '==' 'digital'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vakuus pankkitakauksena",
    value: "#ifCond lease.depositType '==' 'bank'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vakuus maksetaan vuokranantajan tilille",
    value: "#ifCond lease.depositType '==' 'payment'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vakuus siirretään",
    value: "#ifCond lease.depositType '==' 'transfer'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos vakuus maksetaan maksupäätteellä",
    value: "#ifCond lease.depositType '==' 'paymentTerminal'",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos Kelan tai sos.toimen maksusitoumus hyväksytään",
    value: "#if lease.socialWelfareAccepted",
    type: "function",
    show: [1],
  },
  {
    text: "Vakuuden määrä €",
    value: "deposit",
    type: "variable",
    show: [1],
  },
  {
    text: "Vakuuden eräpäivä",
    value: "depositDueDate",
    type: "variable",
    show: [1],
  },
  {
    text: "Vakuusmaksun tilinumero",
    value: "lease.depositIban",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos omavelkainen takaus hyväksytään",
    value: "#if lease.absoluteGuarantee.isUsed",
    type: "function",
    show: [1],
  },
  {
    text: "Takaajan nimi",
    value: "lease.absoluteGuarantee.name",
    type: "variable",
    show: [1],
  },
  {
    text: "Takaajan sotu",
    value: "lease.absoluteGuarantee.social",
    type: "variable",
    show: [1],
  },
  {
    text: "Takaajan max korvattava summa €",
    value: "absoluteGuaranteeMaxAmount",
    type: "variable",
    show: [1],
  },

  // RENT INCREASE
  {
    text: "&Jos vuokraa EI koroteta",
    value: "#if lease.noRentIncrease",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos prosenttikorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'percentage'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos elinkustannusindeksin pistelukukorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'index'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kuluttajaindeksin pistelukukorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'consumerIndex'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteä korotus",
    value: "#ifCond lease.rentIncreaseType '==' 'fixed'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos elinkustannusindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'indexPlusPercentage'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kuluttajaindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'consumerIndexPlusPercentage'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin pisteluku",
    value: "#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceIndex'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'propertyMaintenancePlusPercentageIndex'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pisteluku",
    value: "#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceApartmentIndex'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pisteluku ja prosenttikorotus",
    value: "#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceApartmentPlusPercentageIndex'",
    type: "function",
    show: [1],
  },
  {
    text: "#Jos jokin muu korotusperuste",
    value: "#ifCond lease.rentIncreaseType '==' 'own'",
    type: "function",
    show: [1],
  },
  {
    text: "Vuokrankorotuksen ajankohta",
    value: "lease.rentIncreaseTime",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokran prosenttikorotuksen tarkenne",
    value: "lease.percentagePrefix",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokran prosenttikorotuksen määrä",
    value: "lease.rentIncreasePercentage",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokran kiinteä korotus (€)",
    value: "rentIncreaseFixed",
    type: "variable",
    show: [1],
  },
  {
    text: "Indeksin aloituspisteluku",
    value: "lease.indexStartValue",
    type: "variable",
    show: [1],
  },
  {
    text: "Indeksin pvm. (KK/VVVV)",
    value: "indexStartDateFormatted",
    type: "variable",
    show: [1],
  },
  {
    text: "Indeksin vuosineljännes",
    value: "indexStartDateQ",
    type: "variable",
    show: [1],
  },
  {
    text: "Vuokrankorotuksen oma kuvaus",
    value: "lease.rentIncreaseOwn",
    type: "variable",
    show: [1],
  },
  // Products
  {
    text: "#Useat tuotteet alkaa",
    value: "#each products as |product index|",
    type: "function",
    show: [1, 3],
  },
  {
    text: "Tuotteen nimi",
    value: "product.desc",
    type: "variable",
    show: [1, 3],
  },
  {
    text: "Tuotteen kokonaishinta (hinta * määrä * alv)",
    value: "product.totalAmount",
    type: "variable",
    show: [3],
  },
  {
    text: "Tuotteen hinta",
    value: "product.amount",
    type: "variable",
    show: [1, 3],
  },
  {
    text: "Tuotteen määrä",
    value: "product.count",
    type: "variable",
    show: [1, 3],
  },
  {
    text: "Tuotteen tyyppi",
    value: "product.itemtype",
    type: "variable",
    show: [3],
  },
  {
    text: "Tuotteen Alv %",
    value: "product.taxpr",
    type: "variable",
    show: [3],
  },
  // Rent increase model editor only
  {
    text: "Alkuperäinen sopimuksen korotuspäivä (pp.kk.vvvv)",
    value: "nextRentIncreaseDate",
    type: "variable",
    show: [3],
  },
  {
    text: "Alkuperäinen sopimuksen korotuspäivä (pp.kk)",
    value: "nextRentIncreaseDateNoYear",
    type: "variable",
    show: [3],
  },
  {
    text: "Todellinen korotuspäivä (pp.kk.vvvv)",
    value: "firstDueDate",
    type: "variable",
    show: [3],
  },
  {
    text: "Todellinen korotuspäivä (kuukausi vvvv)",
    value: "firstDueDateMonthYear",
    type: "variable",
    show: [3],
  },
  {
    text: "Korotetun laskun loppusumma sis. avl",
    value: "totalAmountWithVat",
    type: "variable",
    show: [3],
  },
  {
    text: "Ensimmäisen laskun lähetystapa",
    value: "sendType",
    type: "variable",
    show: [3],
  },
  {
    text: "Alkuperäinen vuokra alv 0 % (€)",
    value: "startRentPrice",
    type: "variable",
    show: [3],
  },
  {
    text: "Alkuperäinen indeksi pisteluku",
    value: "startIndexValue",
    type: "variable",
    show: [3],
  },
  {
    text: "Uusi indeksi pisteluku",
    value: "newIndexValue",
    type: "variable",
    show: [3],
  },
  {
    text: "Alkuperäinen indeksi pvm",
    value: "startIndexDate",
    type: "variable",
    show: [3],
  },
  {
    text: "Uusi indeksi pvm",
    value: "newIndexDate",
    type: "variable",
    show: [3],
  },
  {
    text: "Alkuperäinen indeksi vuosineljännes",
    value: "startIndexQ",
    type: "variable",
    show: [3],
  },
  {
    text: "Uusi indeksi vuosineljännes",
    value: "newIndexQ",
    type: "variable",
    show: [3],
  },
  {
    text: "Prosenttikorotuksen määrä (%)",
    value: "percentage",
    type: "variable",
    show: [3],
  },
  {
    text: "Kiinteän korotuksen määrä (€)",
    value: "fixedAmount",
    type: "variable",
    show: [3],
  },
  {
    text: "Jokin muu korotusperuste",
    value: "rentIncreaseOwn",
    type: "variable",
    show: [3],
  },
  {
    text: "Päiväys (pp.kk.vvvv)",
    value: "createdDate",
    type: "variable",
    show: [3],
  },
  {
    text: "#Jos prosenttikorotus",
    value: "#ifCond rentIncreaseType '==' 'percentage'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kiinteä korotus",
    value: "#ifCond rentIncreaseType '==' 'fixed'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos elinkustannusindeksin pistelukukorotus",
    value: "#ifCond rentIncreaseType '==' 'index'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos elinkustannusindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond rentIncreaseType '==' 'indexPlusPercentage'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kuluttajaindeksin pistelukukorotus",
    value: "#ifCond rentIncreaseType '==' 'consumerIndex'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kuluttajaindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond rentIncreaseType '==' 'consumerIndexPlusPercentage'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin pistelukukorotus",
    value: "#ifCond rentIncreaseType '==' 'propertyMaintenanceIndex'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin pisteluku ja prosenttikorotus",
    value: "#ifCond rentIncreaseType '==' 'propertyMaintenancePlusPercentageIndex'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pistelukukorotus",
    value: "#ifCond rentIncreaseType '==' 'propertyMaintenanceApartmentIndex'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pisteluku ja prosenttikorotus",
    value: "#ifCond rentIncreaseType '==' 'propertyMaintenanceApartmentPlusPercentageIndex'",
    type: "function",
    show: [3],
  },
  {
    text: "#Jos jokin muu korotusperuste",
    value: "#ifCond rentIncreaseType '==' 'own'",
    type: "function",
    show: [3],
  },

  // OTHER DATA
  {
    text: "&Jos jälleenvuokraus sallittu",
    value: "#if others.subLeaseAllowed",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos vuokrataan kalustettuna",
    value: "#if others.furnished",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos pakollinen kotivakuutus",
    value: "#if others.mandatoryInsurance",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos lemmikit kiellettyjä",
    value: "#if others.noPets",
    type: "function",
    show: [1],
  },
  {
    text: "&Jos tupakointi kielletty",
    value: "#if others.noSmoking",
    type: "function",
    show: [1],
  },
  {
    text: "Tarkennus lemmikkieläimiin",
    value: "others.petsDetails",
    type: "variable",
    show: [1],
  },
  {
    text: "Muut tarkennukset vuokrasopimukseen",
    value: "others.comments",
    type: "variable",
    show: [1],
  },
  {
    text: "#Jos avaimet määritelty",
    value: "#ifCond others.keys '>' 0",
    type: "function",
    show: [1],
  },
  {
    text: "Avainten määrä",
    value: "others.keys",
    type: "variable",
    show: [1],
  },
  {
    text: "Avainten hävityksen korvaussumma €",
    value: "keysLostSum",
    type: "variable",
    show: [1],
  },
  {
    text: "Allekirjoituspaikka",
    value: "others.signatureCity",
    type: "variable",
    show: [1],
  },
  {
    text: "Allekirjoitus ajankohta",
    value: "signatureDate",
    type: "variable",
    show: [1],
  },
  {
    text: "&Jos digitaalinen sopimus",
    value: "#if isDigital",
    type: "function",
    show: [1, 2],
  },
  {
    text: "Pdf-tulosteen sivunvaihto",
    value: "pageBreak",
    type: "function",
    show: [1, 2],
  },

  // SIGNATURES
  {
    text: "#Useat allekirjoittajat alkaa",
    value: "#each signers as |signer index|",
    type: "function",
    show: [1, 2],
  },
  {
    text: "Allekirjoittajan nimi",
    value: "signer.name",
    type: "variable",
    show: [1, 2],
  },
  {
    text: "Allekirjoittajan allekirjoitus",
    value: "signatureImg signer.signature",
    type: "function",
    show: [1, 2],
  },

  // LOGO
  // {
  //   text: "Logo",
  //   value: "logoImg",
  //   type: "variable",
  //   show: [1, 2, 3],
  // },
];

// DEFAULT TEMPLATE
const defaultRentalContract = `<h1><div style="text-align: center">Vuokrasopimus</div></h1><h2>1. Yhteystiedot</h2><p></p><h3>Vuokranantajat</h3><p></p><p>{{twoSideBySide}}</p><p>{{#each landlords as |landlord index|}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{landlord.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId landlord}}</p><p>Osoite: {{landlord.address}}, {{landlord.zipCode}} {{landlord.city}}</p><p>Puhelinnumero: {{landlord.phone}}</p><p>Sähköpostiosoite: {{landlord.email}}</p><p>{{#if ../others.eInvoice}}{{else}}</p><p>{{#if landlord.iban}}</p><p>Vuokranmaksutili: {{landlord.bank}} {{landlord.iban}}</p><p>{{/if}}</p><p>{{/if}}</p><p></p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><h3></h3><h3>Vuokralaiset</h3><p></p><p>{{twoSideBySide}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{tenant.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId tenant}}</p><p>Osoite: {{tenant.address}}, {{tenant.zipCode}} {{tenant.city}}</p><p>Puhelinnumero: {{tenant.phone}}</p><p>Sähköpostiosoite: {{tenant.email}}</p><p></p><p>{{endDiv}}</p><p>{{#each otherTenants as |tenant index|}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{tenant.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId tenant}}</p><p>Sähköpostiosoite: {{tenant.email}}</p><p></p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><p></p><h2>2. Vuokrauskohde</h2><p></p><p>Osoite: {{apartment.address}}, {{apartment.apartmentNumber}}</p><p>Postinumero: {{apartment.zipCode}} Postitoimipaikka: {{apartment.city}}</p><p>Huoneiston kokoonpano: {{apartment.floorPlan}}</p><p>Pinta-ala noin: {{apartment.area}} m². Vuokratun tilan pinta-alaa ei ole tarkistusmitattu eikä vuokran määrittelyssä ole käytetty perusteena pelkästään pinta-alaa.</p><p>Muut tilat: {{apartment.otherRooms}}</p><p></p><h2>3. Vuokra-aika</h2><p></p><p>Sopimuksen tyyppi: {{lease.leaseType}}</p><p>Sopimuksen alkamispäivä: {{startDate}}</p><p>{{#ifCond lease.leaseType '==' 'Määräaikainen'}}</p><p>Sopimuksen päättymispäivä: {{endDate}}</p><p>{{/ifCond}}</p><p>Vuokranmaksun alkamispäivä: {{firstRentDate}}</p><p>{{#if lease.showDismissalDate}}</p><p>Irtisanomisen ensimmäinen mahdollinen alkamispäivä on {{dismissalDate}} Kyseessä on sopimusrikkomus, jos sopimus irtisanotaan siten, että irtisanomisaika alkaa ennen edellä mainittua ajankohtaa. Sopimusrikkomuksesta on irtisanovan osapuolen maksettava sopimussakkona toiselle osapuolelle 2 kuukauden vuokraa vastaava summa.</p><p>{{/if}}</p><p></p><h2>4. Muuttopäivä</h2><p></p><p><strong>Sisäänmuutto</strong></p><p>Sisäänmuuttopäivä on {{moveInDate}}</p><p></p><p><strong>Ulosmuutto</strong></p><p>{{#ifCond lease.moveOut '==' 'AHVL'}}</p><p>AHVL:n mukainen. Lain mukaan muuttopäivä on vuokrasopimuksen päättymispäivän jälkeinen arkipäivä. Muuttopäivänä vuokralaisen on jätettävä puolet huoneistosta vuokranantajan käytettäväksi. Muuttopäivää seuraavana päivänä vuokralaisen on jätettävä huoneisto tyhjennettynä ja siivottuna kokonaan vuokranantajan hallintaan.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.moveOut '==' 'LHVL'}}</p><p>LHVL:n mukainen.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.moveOut '==' 'endDate'}}</p><p>Muuttopäivästä on sovittu AHVL:sta poikkeavalla tavalla. Muuttopäivä on sopimuksen päättymispäivä, jolloin huoneisto on luovutettava tyhjennettynä ja siivottuna kokonaan vuokranantajan käytettäväksi.</p><p>{{/ifCond}}</p><p></p><h2>5. Vuokra</h2><p></p><p>Vuokran määrä: {{rentAmount}}</p><p>Eräpäivä: {{lease.rentDueDate}}</p><p>Viivästyskorko peritään voimassa olevan korkolain mukaan.</p><p></p><p><strong>Vuokranmaksun yhteydessä suoritettavat korvaukset:</strong></p><p>{{#ifCond lease.waterChargeType '==' 'usage'}}</p><p>Vesimaksu: {{waterChargePerMonth}}/hlö/kk. Vesimaksu määräytyy kulutuksen mukaan.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.waterChargeType '==' 'fixed'}}</p><p>Kiinteä vesimaksu {{waterChargePerMonth}}/hlö/kk.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.waterChargeType '==' 'included'}}</p><p>Vesimaksu sisältyy vuokraan.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.waterChargeType '==' 'noCharge'}}</p><p>Ei vesimaksua.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.electricity '==' 'own'}}</p><p>Vuokralainen maksaa sähkön kulutuksen perusteella suoraan energialaitokselle tekemänsä sähkösopimuksen mukaisesti. Sähkösopimus on pidettävä voimassa koko vuokrasuhteen ajan.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.electricity '==' 'fixed'}}</p><p>Sähkömaksu on {{electricityAmount}}/kk.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.electricity '==' 'included'}}</p><p>Sähkömaksu sisältyy vuokraan.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.electricity '==' 'noCharge'}}</p><p>Ei sähkömaksua.</p><p>{{/ifCond}}</p><p></p><p><strong>Muut erilliskorvaukset:</strong></p><p>Autopaikka: {{parkingCost}}/kk</p><p>Saunavuoro: {{saunaCost}}</p><p>Pyykkitupa: {{laundretteCost}}</p><p></p><p>{{#if others.eInvoice}}</p><p><strong>Vuokranmaksu</strong></p><p>Laskutus tapahtuu Ropo Oy:n (2495037-7) kautta. Kokoelmalaskut lähetetään postilla tai emailina.</p><p>{{/if}}</p><p></p><h2>6. Vakuus</h2><p></p><p>{{#if lease.useDeposit}}</p><p>Vakuuden määrä: {{deposit}}</p><p>{{#ifCond lease.depositType '==' 'payment'}}</p><p>Vakuus maksetaan ja talletetaan tilille {{lease.depositIban}}. Vakuuden eräpäivä on {{depositDueDate}}.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.depositType '==' 'bank'}}</p><p>Vakuus talletetaan pankin vuokravakuustilille ja talletuksesta annetaan talletustodistus vuokranantajalle.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.depositType '==' 'invoice'}}</p><p>Vakuus laskukutetaan erillisellä laskulla ja talletetaan vuokrantajan tilille.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.depositType '==' 'transfer'}}</p><p>Vakuus siirretään vuokralaisen edelliseltä vuokrasopimukselta tälle sopimukselle.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.depositType '==' 'paymentTerminal'}}</p><p>Vakuus maksetaan maksupäätteellä vuokrasopimuksen allekirjoituksen yhteydessä.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.depositType '==' 'digital'}}</p><p>Vakuutena käytetään digitaalista vakuutta. Erillistä rahavakuutta ei peritä.</p><p>{{/ifCond}}</p><p>{{#if lease.socialWelfareAccepted}}</p><p>Vakuudeksi hyväksytään Kelan tai sosiaalitoimen maksusitoumus.</p><p>{{else}}</p><p>Kelan tai sosiaalitoimen maksusitoumusta ei hyväksytä vakuudeksi.</p><p>{{/if}}</p><p>{{else}}</p><p>Vakuutta ei peritä.</p><p>{{/if}}</p><p>{{#if lease.absoluteGuarantee.isUsed}}</p><p>Tämän sopimuksen velvoitteiden täyttämisen vakuudeksi {{lease.absoluteGuarantee.name}} ({{lease.absoluteGuarantee.social}}) sitoutuu omavelkaiseen takaukseen, enintään {{absoluteGuaranteeMaxAmount}} saakka. Takauksesta on laadittu erillinen takaussitoumus.</p><p>{{/if}}</p><p></p><h2>7. Vuokran korottaminen</h2><p></p><p>{{#if lease.noRentIncrease}}</p><p>Vuokraa ei koroteta vuosittain.</p><p>{{else}}</p><p>Vuokran tarkistusajankohta vuosittain: {{lease.rentIncreaseTime}}</p><p></p><p>{{#ifCond lease.rentIncreaseType '==' 'percentage'}}</p><p>Vuokraa korotetaan {{lease.percentagePrefix}} {{lease.rentIncreasePercentage}} prosentilla vuodessa.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'index'}}</p><p>Vuokraa korotetaan elinkustannusindeksin muutoksia vastaavasti. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}}. Tarkistusindeksi on tarkistusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'consumerIndex'}}</p><p>Vuokraa korotetaan kuluttajaindeksin muutoksia vastaavasti. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}}. Tarkistusindeksi on tarkistusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'fixed'}}</p><p>Vuokraa korotetaan maksimissaan {{rentIncreaseFixed}} vuodessa.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'indexPlusPercentage'}}</p><p>Vuokraa korotetaan elinkustannusindeksin muutoksia vastaavasti ja {{lease.percentagePrefix}} {{lease.rentIncreasePercentage}} prosenttia vuodessa. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}}. Tarkistusindeksi on tarkustusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'consumerIndexPlusPercentage'}}</p><p>Vuokraa korotetaan kuluttajaindeksin muutoksia vastaavasti ja {{lease.percentagePrefix}} {{lease.rentIncreasePercentage}} prosenttia vuodessa. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}}. Tarkistusindeksi on tarkustusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceIndex'}}</p><p>Vuokraa korotetaan kiinteistön ylläpidon kustannusindeksin muutoksia vastaavasti. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}} ({{indexStartDateQ}}). Tarkistusindeksi on tarkistusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'propertyMaintenancePlusPercentageIndex'}}</p><p>Vuokraa korotetaan kiinteistön ylläpidon kustannusindeksin muutoksia vastaavasti ja {{lease.percentagePrefix}} {{lease.rentIncreasePercentage}} prosenttia vuodessa. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}} ({{indexStartDateQ}}). Tarkistusindeksi on tarkustusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceApartmentIndex'}}</p><p>Vuokraa korotetaan kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) muutoksia vastaavasti. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}} ({{indexStartDateQ}}). Tarkistusindeksi on tarkistusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'propertyMaintenanceApartmentPlusPercentageIndex'}}</p><p>Vuokraa korotetaan kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) muutoksia vastaavasti ja {{lease.percentagePrefix}} {{lease.rentIncreasePercentage}} prosenttia vuodessa. Perusindeksin pisteluku on sopimuksen tekohetkellä {{lease.indexStartValue}} ({{indexStartDateQ}}). Tarkistusindeksi on tarkustusajankohtana tiedossa oleva viimeksi julkaistu pisteluku.</p><p>{{/ifCond}}</p><p>{{#ifCond lease.rentIncreaseType '==' 'own'}}</p><p>{{lease.rentIncreaseOwn}}</p><p>{{/ifCond}}</p><p></p><p>Vesimaksut ja muut taloyhtiön maksut nousevat tai alenevat vuosittain taloyhtiön yhtiökokouksen tekemän päätöksen mukaisesti. Milloin vuokranantaja haluaa tarkistaa vuokraa edellä sovitulla perusteella, hänen on ilmoitettava siitä vuokralaiselle kirjallisesti tai sähköpostitse kuukautta ennen korotuksen voimaantuloa. Samalla on ilmoitettava uusi vuokra, erilliskorvausten määrä ja niiden voimaantuloajankohta.</p><p>{{/if}}</p><p></p><h2>8. Muutostyöt</h2><p></p><p>Lain mukaan vuokralaisella ei ole oikeutta tehdä muutos- tai korjaustöitä vuokratussa tilassa ilman vuokranantajan lupaa. Tällaisina luvanvaraisina töinä pidetään muun muassa maalausta, tapetointia ja kiinteiden kalusteiden vaihtamista.</p><p></p><h2>9. Muut ehdot</h2><p></p><p>{{#if others.subLeaseAllowed}}</p><p>Vuokrakohteen jälleenvuokraus on sallittu.</p><p>{{else}}</p><p>Vuokrakohteen jälleenvuokraus on kielletty.</p><p></p><p>{{/if}}</p><p>{{#if others.furnished}}</p><p>Asunto vuokrataan kalustettuna.</p><p></p><p>{{/if}}</p><p>{{#if others.mandatoryInsurance}}</p><p>Vuokralaisella tulee olla koko vuokrasuhteen ajan voimassa oleva kotivakuutus vastuuvakuutusosineen. Todistus vakuutuksen voimassaolosta on esitettävä vuokranantajalle ennen vuokrakohteen hallinnan luovutusta.</p><p></p><p>{{/if}}</p><p>{{#if others.noPets}}</p><p>Vuokrakohteessa ei saa pitää lemmikkieläimiä.</p><p></p><p>{{else}}</p><p>Vuokrakohteessa saa pitää lemmikkieläimiä. {{others.petsDetails}}</p><p></p><p>{{/if}}</p><p>{{#if others.noSmoking}}</p><p>Vuokrakohteessa tupakointi on kielletty.</p><p></p><p>{{/if}}</p><p>{{#ifCond others.keys '>' 0}}</p><p>Vuokralaiselle luovutetaan vuokrakohteen hallinnan yhteydessä {{others.keys}} kappaletta avaimia. Mikäli vuokralainen ei palauta alun perin saamiaan avaimia vuokrasuhteen päättyessä, maksaa vuokralainen sopimussakkona {{keysLostSum}}</p><p></p><p>{{/ifCond}}</p><p>Vuokralainen vastaa lumen, jään ja roskien poistamisesta parvekkeelta tarpeen vaatiessa. Vuokralainen on velvollinen tekemään muuttoilmoituksen isännöitsijälle tai huoltoyhtiölle.</p><p></p><p>Vuokralaisen on ilmoitettava vuokranantajalle, jos vuokrakohteeseen muuttaa vuokralaisen lisäksi muita henkilöitä. Vuokralainen sitoutuu noudattamaan taloyhtiön tai kiinteistön järjestyssääntöjä ja huolehtii siitä, että vuokrakohteessa on riittävästi toimivia palovaroittimia. Vuokralainen on tietoinen siitä, että vuokranantajalla on ollut luottotietolain nojalla oikeus tarkistaa vuokralaisen luottotiedot ennen tämän vuokrasopimuksen tekemistä. Vuokranantaja on ilmoittanut, mihin hänen oikeutensa vuokrata kohde perustuu.</p><p></p><h2>10. Allekirjoitukset</h2><p></p><p>Sopimusehtojen lisäksi tähän vuokrasuhteeseen sovelletaan lakia asuinhuoneiston vuokrauksesta (481/1995) siihen tehtyine muutoksineen sekä noudatetaan alalla hyväksyttyä hyvää vuokratapaa.</p><p></p><p>Tämä vuokrasopimus on laadittu ja allekirjoitettu kahtena samansanaisena alkuperäiskappaleena, yksi kummallekin osapuolelle.</p><p></p><p>Paikka ja aika: {{others.signatureCity}}, {{signatureDate}}</p><p></p><p></p><p>{{#if isDigital}}</p><p>{{else}}</p><p><strong>Allekirjoitukset ja nimenselvennykset:</strong></p><p></p><p>{{twoSideBySide}}</p><p>{{#each signers as |signer index|}}</p><p>{{sideBySideItem}}</p><p>{{signatureImg signer.signature}}</p><p>{{signer.name}}</p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><p>{{/if}}</p>`;
const defaultOtherContract = `<h1><div style="text-align: center">Sopimus</div></h1><h2>1. Yhteystiedot</h2><p></p><h3>Vuokranantajat</h3><p></p><p>{{twoSideBySide}}</p><p>{{#each landlords as |landlord index|}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{landlord.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId landlord}}</p><p>Osoite: {{landlord.address}}, {{landlord.zipCode}} {{landlord.city}}</p><p>Puhelinnumero: {{landlord.phone}}</p><p>Sähköpostiosoite: {{landlord.email}}</p><p>{{#if ../others.eInvoice}}{{else}}</p><p>{{#if landlord.iban}}</p><p>Vuokranmaksutili: {{landlord.bank}} {{landlord.iban}}</p><p>{{/if}}</p><p>{{/if}}</p><p></p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><h3></h3><h3>Vuokralaiset</h3><p></p><p>{{twoSideBySide}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{tenant.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId tenant}}</p><p>Osoite: {{tenant.address}}, {{tenant.zipCode}} {{tenant.city}}</p><p>Puhelinnumero: {{tenant.phone}}</p><p>Sähköpostiosoite: {{tenant.email}}</p><p></p><p>{{endDiv}}</p><p>{{#each otherTenants as |tenant index|}}</p><p>{{sideBySideItem}}</p><p>Nimi: {{tenant.name}}</p><p>Henkilötunnus tai Y-tunnus: {{socialOrBusinessId tenant}}</p><p>Sähköpostiosoite: {{tenant.email}}</p><p></p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><p></p><h2>3. Vuokrauskohde</h2><p></p><p>Osoite: {{apartment.address}}, {{apartment.apartmentNumber}}</p><p>Postinumero: {{apartment.zipCode}} Postitoimipaikka: {{apartment.city}}</p><p>Huoneiston kokoonpano: {{apartment.floorPlan}}</p><p>Pinta-ala noin: {{apartment.area}} m².</p><p></p><h2>3. Avain</h2><h3>Luovutetut avaimet</h3><p></p><p>{{#each keys as |key index|}}</p><p>Avainkoodi: {{key.code}}</p><p>{{/each}}</p><p></p><p></p><p>{{#if isDigital}}</p><p>{{else}}</p><h2>4. Allekirjoitukset</h2><p></p><p><strong>Allekirjoitukset ja nimenselvennykset:</strong></p><p></p><p>{{twoSideBySide}}</p><p>{{#each signers as |signer index|}}</p><p>{{sideBySideItem}}</p><p>{{signatureImg signer.signature}}</p><p>{{signer.name}}</p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p><p>{{/if}}</p>`;
const defaultRentIncrease = `<h1>Ilmoitus vuokrankorotuksesta {{nextRentIncreaseDate}} lukien</h1><p>Vuokrakohteen osoite: {{apartment.address}} {{apartment.apartmentNumber}}, {{apartment.zipCode}} {{apartment.city}}.</p><p></p><p>Sopimuksemme mukaan vuokraa korotetaan vuosittain {{nextRentIncreaseDateNoYear}}.</p><p></p><p><strong>Korotuksen tiedot</strong></p><p>{{#ifCond rentIncreaseType '==' 'percentage'}}</p><p>Prosenttikorotuksen määrä: {{percentage}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'fixed'}}</p><p>Kiinteän korotuksen määrä: {{fixedAmount}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'index'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen elinkustannusindeksin pisteluku: ({{startIndexDate}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexDate}}) {{newIndexValue}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'consumerIndex'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kuluttajaindeksin pisteluku: ({{startIndexDate}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexDate}}) {{newIndexValue}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'consumerIndexPlusPercentage'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kuluttajaindeksin pisteluku: ({{startIndexDate}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexDate}}) {{newIndexValue}}</p><p>Prosenttikorotuksen määrä: {{percentage}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'indexPlusPercentage'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen elinkustannusindeksin pisteluku: ({{startIndexDate}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexDate}}) {{newIndexValue}}</p><p>Prosenttikorotuksen määrä: {{percentage}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'propertyMaintenanceIndex'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kiinteistön ylläpidon kustannusindeksin pisteluku: ({{startIndexQ}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexQ}}) {{newIndexValue}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'propertyMaintenancePlusPercentageIndex'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kiinteistön ylläpidon kustannusindeksin pisteluku: ({{startIndexQ}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexQ}}) {{newIndexValue}}</p><p>Prosenttikorotuksen määrä: {{percentage}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'propertyMaintenanceApartmentIndex'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pisteluku: ({{startIndexQ}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexQ}}) {{newIndexValue}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'propertyMaintenanceApartmentPlusPercentageIndex'}}</p><p>Alkuperäinen vuokra: {{startRentPrice}}</p><p>Alkuperäinen kiinteistön ylläpidon kustannusindeksin (Asuinkerrostalo) pisteluku: ({{startIndexQ}}) {{startIndexValue}}</p><p>Korotusajan pisteluku: ({{newIndexQ}}) {{newIndexValue}}</p><p>Prosenttikorotuksen määrä: {{percentage}}</p><p>{{/ifCond}}</p><p>{{#ifCond rentIncreaseType '==' 'own'}}</p><p>{{rentIncreaseOwn}}</p><p>{{/ifCond}}</p><p></p><p><strong>Tuotteet</strong></p><p>{{#each products as |product index|}}</p><p>{{product.desc}} {{product.totalAmount}} (Alv {{product.taxpr}})</p><p>{{/each}}</p><p></p><p>Kokonaisvuokran määrä alkaen {{firstDueDate}} on {{totalAmountWithVat}}.</p><p></p><p>Päivitettyä vuokranmaksua varten saat vuokranmaksuerittelyn ensi kuun aikana. Laskun lähetystapa on {{sendType}} ja eräpäivä {{firstDueDate}}.</p><p></p><p>Muista aina maksaessasi käyttää viitenumeroa, niin maksusi kohdistuu oikein.</p><p></p><p></p><p><strong>Ystävällisin terveisin:</strong></p><p></p><p>{{twoSideBySide}}</p><p>{{#each landlords as |landlord index|}}</p><p>{{sideBySideItem}}</p><p>{{landlord.name}}</p><p>{{landlord.address}}, {{landlord.zipCode}} {{landlord.city}}</p><p>{{landlord.phone}}</p><p>{{landlord.email}}</p><p></p><p>{{endDiv}}</p><p>{{/each}}</p><p>{{endDiv}}</p>`;

export default {
  variables: variables,
  defaultRentalContract,
  defaultOtherContract,
  defaultRentIncrease,
};
